<template>
  <!-- 账号管理-单个账户页面 -->
  <div class="single-box">
    <!-- <span style="color:#fff;">{{accountInfo}}</span> -->
    <!-- <span style="color:#fff;">{{usrDatas}}</span> -->
    <!-- <span style="color:#fff;">{{resetform}}</span> -->
    <!-- <span style="color:#fff;">用户状态enableNew：{{accountInfo.enableNew}}</span> -->

    <div class="single-info">
      <div class="info-status">
        <!-- 昵称 -->
        <div>
          <el-input
            class="info-title"
            :placeholder="this.$t('basic.Ple_Nickname')"
            v-model="qnameData.qname"
            @change="editNickname"
          ></el-input>
          <!-- <el-input class="info-title" v-else v-model="qnameData.qname" @change="editNickname" ></el-input> -->
        </div>
        <!-- <input type="text" class="info-title"> -->
        <!-- <span class="info-title">{{`${accountInfo.qnameNew || accountInfo.usrNew}`}}</span> -->
        <!-- 启用禁用状态 -->
        <i
          class="iconfont icon-qiyong1 info-enable"
          :class="{ 'info-enable-yes': accountInfo.enableNew }"
        ></i>
        <!-- 活跃度 -->
        <span
          class="info-active"
          :class="{
            'info-active-yes': accountInfo.activeNew.class == 'active',
          }"
          >{{
            `${
              accountInfo.activeNew.class == "active"
                ? $t("statistic.active")
                : $t("statistic.inactive")
            }`
          }}</span
        >
      </div>
      <div class="info-tool">
        <div class="tool-box">
          <!-- 返回账户总列表 -->
          <el-button type="text" class="operation" @click="backAccountList">
            <i class="iconfont icon-fanhui1"></i>
            <span class="icon-text1">{{ $t("project.back") }}</span>
          </el-button>
          <!-- 进入主页 -->
          <!-- :title="$t('account.enterHome')" -->
          <el-button
            type="text"
            class="operation"
            @click="enterAccount(accountInfo)"
          >
            <i class="iconfont icon-shouyedianji"></i>
            <span class="icon-text1">{{ $t("account.enterHome") }}</span>
          </el-button>
          <!-- 编辑 -->
          <!-- :title="$t('account.Edit')" -->
          <el-button
            type="text"
            class="operation"
            @click="editcount(accountInfo)"
          >
            <i class="iconfont icon-bianji"></i>
            <span class="icon-text1">{{ $t("account.Edit") }}</span>
          </el-button>
          <!-- 禁用[单独配置] -->
          <!-- v-show="accountInfo.enable.class=='active'" -->
          <!-- :title="$t('account.disable')" -->
          <el-button
            type="text"
            class="operation"
            v-show="accountInfo.enableNew.class == 'active'"
            @click="disablecount(accountInfo)"
          >
            <i class="iconfont icon-caozuo_jinyong"></i>
            <span class="icon-text1">{{ $t("account.disable") }}</span>
          </el-button>
          <!-- v-show="accountInfo.enable.class=='inactive'" -->
          <!-- :title="$t('account.enable')" -->
          <el-button
            type="text"
            class="operation"
            v-show="accountInfo.enableNew.class == 'inactivedis'"
            @click="disablecount(accountInfo)"
          >
            <i class="iconfont icon-caozuo_qiyong"></i>
            <span class="icon-text1">{{ $t("account.enable") }}</span>
          </el-button>
          <!-- 分组 -->
          <!-- <el-button
            type="text"
            class="operation"
            :title="$t('account.group')"
            @click="groupcount()"
          >
            <i class="iconfont icon-caozuo_fenzu"></i>
          </el-button> -->
          <!-- 重置密码 -->
          <!-- :title="$t('account.resetPwd')" -->
          <el-button
            type="text"
            class="operation"
            @click="resetpwd(accountInfo)"
          >
            <i class="iconfont icon-caozuo_zhongzhimima"></i>
            <span class="icon-text1">{{ $t("account.resetPwd") }}</span>
          </el-button>
          <!-- 删除 -->
          <!-- :title="$t('account.Delete')" -->
          <el-button
            type="text"
            class="operation"
            @click="detelecount(accountInfo)"
            style="
              background-color: rgba(221, 104, 67, 0.5);
              border: 1px solid #dd6843;
            "
          >
            <i class="iconfont icon-caozuo_shanchu"></i>
            <span class="icon-text1">{{ $t("account.Delete") }}</span>
          </el-button>
        </div>
      </div>
    </div>
    <div class="info-base">
      <!-- 个人信息 -->
      <div class="info-leftbox">
        <img
          :src="`${
            accountInfo.avatarNew ? accountInfo.avatarNew : defaultAvatar
          }`"
          alt=""
          class="info-avatar"
        />
        <div class="info-databox">
          <div>
            <p>{{ $t("account.accountName") }}</p>
            <p>{{ `${accountInfo.usrNew || "--"}` }}</p>
          </div>
          <div>
            <p>{{ $t("account.nickname") }}</p>
            <p>{{ `${accountInfo.qnameNew || "--"}` }}</p>
          </div>
          <div>
            <p>{{ $t("account.role") }}</p>
            <p
              v-if="
                accountInfo.roleType == 2 &&
                $store.state.user.riyueyuanPermissionMark &&
                $store.state.user.riyueyuanUserTypeRid == 1
              "
            >
              {{ $t("account.riyueyuan_SonAdmin") }}
            </p>
            <!-- <p v-else-if="accountInfo.roleType == 2&&$store.state.user.riyueyuanPermissionMark&&$store.state.user.riyueyuanUserTypeRid ==2">{{$t('account.riyueyuan_lineSonAdmin')}}</p> -->
            <p v-else>{{ `${accountInfo.roleNew || "--"}` }}</p>
          </div>
          <div class="groupBox">
            <p>{{ $t("account.accountGroup") }}</p>
            <!-- <div class="groupName">
              <p>{{`${accountInfo.groupNew || '--'}`}}</p>
              <div class="groupName1">
                1111
              </div>
            </div> -->
            <el-select
              v-model="groupListData1.id"
              :placeholder="accountInfo.groupNew"
              class="groupName2"
              :popper-append-to-body="false"
              @change="editGroup()"
              @visible-change="editGroupVisible"
            >
              <el-option
                v-for="(item, key) in groupListData"
                :key="key"
                :value="item.id"
                :disabled="
                  disPermissionsLogo && !btnList.includes('group')
                    ? true
                    : false
                "
                :label="item.name"
              ></el-option>
            </el-select>
          </div>
          <div>
            <p>{{ $t("signup.mobile_pl") }}</p>
            <p>{{ `${accountInfo.mobileNew || "--"}` }}</p>
          </div>
          <div>
            <p>{{ $t("signup.email") }}</p>
            <p>{{ `${accountInfo.emailNew || "--"}` }}</p>
          </div>
          <hr />
          <div>
            <p>{{ $t("account.projectNum ") }}</p>
            <p>{{ `${accountInfo.pname || "1"}` }}</p>
          </div>
          <div>
            <p>{{ $t("account.deviceNum ") }}</p>
            <p>{{ `${accountInfo.devicesNew || "--"}` }}</p>
          </div>
          <div>
            <p>{{ $t("account.dataloggerNum") }}</p>
            <p>{{ `${accountInfo.collectorsNew || "--"}` }}</p>
          </div>
        </div>
      </div>
      <!-- 设备列表 -->
      <div class="single-deviceList">
        <!-- 设备总计 -->
        <div class="total-top">
          {{ `${$t("account.ownedDevices")} (${deviceNum})` }}
        </div>

        <div class="tablebox" style="overflow: auto">
          <!-- @selection-change="changeFun" -->
          <!-- height="100%" -->
          <el-table
            :data="deviceList"
            border
            stripe
            :row-style="{ height: 0 }"
            :cell-style="{ padding: 0 }"
            :header-cell-style="{
              background: 'rgb(65, 80, 90)',
              color: '#ffffff',
            }"
            :empty-text="$t('message.nodata')"
            v-loading="loadingDevice"
            element-loading-spinner="el-icon-loading"
            class="tablemain tableloding"
          >
            <!-- <el-table-column fixed type="selection"></el-table-column> -->
            <el-table-column
              fixed
              prop="status"
              min-width="80px;"
              :show-overflow-tooltip="true"
              :label="$t('device.device_status')"
            >
              <template slot-scope="scope">
                <span class="label">
                  <i
                    class="status-icon-shadow"
                    :class="$filter.deviceStatus[scope.row.status].class"
                  ></i>
                </span>
                <!-- <span
                v-if="scope.row.status!==undefined"
                :class="`color-${$filter.deviceStatus[scope.row.status].name}`"
              >{{$filter.deviceStatus[scope.row.status].label}}</span> -->
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              min-width="170px;"
              :label="$t('device.device_name')"
            >
              <template slot-scope="scope">
                <span
                  class="redirect"
                  @click="enterDevice(scope.row)"
                  :title="scope.row.devalias || scope.row.sn"
                  >{{ scope.row.devalias || scope.row.sn }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              min-width="170px;"
              :show-overflow-tooltip="true"
              :label="$t('device.device_sn')"
            >
              <template slot-scope="scope">
                <span :title="scope.row.deviceSn||scope.row.sn || '--'">{{
                  scope.row.deviceSn || scope.row.sn || "--"
                }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
            prop="brand"
            :show-overflow-tooltip="true"
            :label="$t('device.device_type')"
          >
            <template slot-scope="scope">
              {{scope.row.brand | translateDeviceType}}
            </template>
          </el-table-column>-->
            <el-table-column
              prop="devcode"
              min-width="90px;"
              :show-overflow-tooltip="true"
              :label="$t('device.device_code')"
            ></el-table-column>
            <el-table-column
              prop="pn"
              min-width="135px;"
              :show-overflow-tooltip="true"
              :label="$t('device.datalogger_pn')"
            ></el-table-column>
            <el-table-column
              min-width="140px;"
              :show-overflow-tooltip="true"
              :label="$t('device.coll_alias')"
            >
              <template slot-scope="scope">
                <span :title="scope.row.collalias || '--'">{{
                  scope.row.collalias || "--"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="devaddr"
              min-width="100px;"
              :show-overflow-tooltip="true"
              :label="$t('device.device_address')"
            ></el-table-column>
            <!-- 暂无数据 -->
            <div v-show="emptyText" slot="empty">
              <!-- <img src="@/assets/img/empty_text.png" /> -->
              <div style="line-height: 32px">{{ $t("account.nodata") }}</div>
            </div>
          </el-table>
        </div>

        <div class="tablebottom" v-show="paginationControl">
          <el-pagination
            class="pagination"
            background
            @size-change="getDeviceList(true)"
            @current-change="() => getDeviceList()"
            :current-page.sync="pagination.currentPage"
            :page-sizes="[10, 15, 20, 30, 50]"
            :page-size.sync="pagination.pagesize"
            layout="slot, sizes, total, pager, prev, next, jumper"
            :total="pagination.total"
            popper-class="select-page"
          >
            <span style="color: #ffffff; padding-left: 15px"
              >{{ $t("device.pageSize") }} :</span
            >
          </el-pagination>
        </div>
      </div>
    </div>

    <!--编辑用户弹窗 -->
    <!-- v-if="showEditcountDialog" -->
    <account-dialog
      :title="$t('account.editUser')"
      :visible.sync="showEditcountDialog"
      :width="'500px'"
      :class="{
        showDialog: showEditcountDialog,
        hideDialog: !showEditcountDialog,
      }"
      noFooter
    >
      <el-form
        ref="editForm"
        :model="usrDatas"
        :rules="editRules"
        slot="content"
        class="bianji grid"
        element-loading-spinner="el-icon-loading"
        v-loading="loadingeditcount"
      >
        <el-form-item :label="$t('account.role1')">
          <el-input
            v-if="
              accountInfo.roleType == 2 &&
              $store.state.user.riyueyuanPermissionMark &&
              $store.state.user.riyueyuanUserTypeRid == 1
            "
            :value="this.$t('account.riyueyuan_SonAdmin')"
            auto-complete="off"
            disabled
          ></el-input>
          <!-- <el-input v-else-if="accountInfo.roleType == 2&&$store.state.user.riyueyuanPermissionMark&&$store.state.user.riyueyuanUserTypeRid ==2" :value="this.$t('account.riyueyuan_lineSonAdmin')" auto-complete="off" disabled></el-input> -->
          <el-input v-else :value="usrDatas.role" auto-complete="off" disabled>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.accountName1')">
          <el-input v-model="usrDatas.usr" auto-complete="off" disabled>
            <!-- <img slot="prefix" src="@/assets/img/nicheng.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.nickname1')">
          <el-input clearable v-model="usrDatas.qname" auto-complete="off">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.mobile1')" prop="mobile">
          <el-input clearable type="text" v-model="usrDatas.mobile">
            <!-- <img slot="prefix" src="@/assets/img/shouji.png" style="width:13px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.email1')" prop="email">
          <el-input clearable v-model="usrDatas.email" auto-complete="off">
            <!-- <img slot="prefix" src="@/assets/img/youxiang.png" style="width:19px;height:14px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('account.Related_roles')"
          prop="roleId"
          v-if="this.$store.state.user.role == 1 && params.roleType == 2"
        >
          <el-select
            v-model="usrDatas.roleId"
            :placeholder="$t('account.Ple_role1')"
            popper-class="select-search-recharge"
            clearable
          >
            <el-option
              v-for="(item, index) in DistRoleList"
              :key="index"
              :label="item.roleName"
              :value="item.roleId"
            ></el-option>
          </el-select>
        </el-form-item>
        <div
          v-if="
            this.$store.state.user.role == 1 &&
            params.roleType == 2 &&
            params.riyueyuanUserTypeRid == 0
          "
          style="max-width: 150px; word-break: break-all"
        >
          {{ $t("account.dataogger_swith") }}:
        </div>
        <div
          style="
            position: relative;
            margin-left: 20px;
            display: flex;
            align-items: center;
          "
          v-if="
            this.$store.state.user.role == 1 &&
            params.roleType == 2 &&
            params.riyueyuanUserTypeRid == 0
          "
        >
          <i
            class="el-icon-check"
            v-if="dataoggerSwithControl"
            style="
              position: absolute;
              z-index: 1;
              left: 12px;
              top: 50%;
              margin-top: -7px;
            "
          ></i>
          <el-switch
            class="eb-switch"
            v-model="dataoggerSwithControl"
            :width="50"
          >
          </el-switch>
          <span class="help-label">{{ $t("account.dataogger_swithTip") }}</span>
        </div>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align: right">
          <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
          <button type="button" class="btn btn-dark" @click="editoldcount">
            {{ $t("account.confirm") }}
          </button>
        </div>
      </el-form>
      <div slot="footer">
        <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
        <!-- <button class="button-solid" @click="editoldcount">{{$t('account.confirm')}}</button> -->
      </div>
    </account-dialog>
    <!-- 编辑账号结果提示(成功) -->
    <!-- v-if="editAccountSucVisible" -->
    <account-dialog
      :title="$t('account.editAccount')"
      :visible.sync="editAccountSucVisible"
      :class="{
        showDialog: editAccountSucVisible,
        hideDialog: !editAccountSucVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{
            $t("account.modifiedsuccess")
          }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editAccountSucVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 编辑账号结果提示(失败) -->
    <!-- v-if="editAccountFailVisible" -->
    <account-dialog
      :title="$t('account.editAccount')"
      :visible.sync="editAccountFailVisible"
      :class="{
        showDialog: editAccountFailVisible,
        hideDialog: !editAccountFailVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button
              class="btn btn-dark"
              @click="editAccountFailVisible = false"
            >
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </account-dialog>

    <!-- 禁用/启用用户 去掉弹框的heard不加title=""和footer noFooter -->
    <account-dialog-if
      :title="disAndEnTitle"
      :visible.sync="showdisablecountDialog"
      :width="'450px'"
      v-if="showdisablecountDialog"
      noFooter
    >
      <!-- 启用 -->
      <div
        v-if="this.params.enable.class == 'active' ? true : false"
        slot="content"
        class="content_tishi"
      >
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span
            class="contentdelete"
            style="width: 100%; text-align: left; color: rgba(255, 62, 62, 1)"
            >{{ `${$t("account.confirmDisable")}` }}</span
          >
        </div>
        <!-- <div class="disablecontent">{{$t('account.confirmDisable')}}</div> -->
        <div class="disabledescr">
          <span
            style="
              width: 100%;
              text-align: left;
              margin-top: 28px;
              color: rgba(255, 255, 255, 0.7);
            "
            >{{ $t("account.afterDisable") }}</span
          >
        </div>
        <div class="deletfotter" style="text-align: right; margin-top: 28px">
          <button
            type="button"
            class="btn btn-dark"
            style="margin-right: 10px"
            @click="disableoldcount"
          >
            {{ $t("account.confirm") }}
          </button>
          <button
            type="button"
            class="btn btn-light"
            @click="showdisablecountDialog = false"
          >
            {{ $t("account.cancel") }}
          </button>
        </div>
      </div>
      <!-- 禁用 -->
      <div
        v-if="this.params.enable.class == 'inactivedis' ? true : false"
        slot="content"
        class="content_tishi"
      >
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <div
            class="contentdelete"
            style="width: 100%; text-align: left; color: rgba(73, 222, 255, 1)"
          >
            {{ `${$t("account.confirmEnable")}` }}
          </div>
        </div>
        <!-- <div class="disablecontent">{{$t('account.confirmEnable')}}</div> -->
        <div class="disabledescr">
          <span
            style="
              width: 100%;
              text-align: left;
              margin-top: 28px;
              color: rgba(255, 255, 255, 0.7);
            "
            >{{ $t("account.afterEnable") }}</span
          >
        </div>
        <div class="deletfotter" style="text-align: right; margin-top: 28px">
          <button
            type="button"
            class="btn btn-dark"
            style="margin-right: 10px"
            @click="disableoldcount"
          >
            {{ $t("account.confirm") }}
          </button>
          <button
            type="button"
            class="btn btn-light"
            @click="showdisablecountDialog = false"
          >
            {{ $t("account.cancel") }}
          </button>
        </div>
      </div>
      <!-- <div class="deletfotter">
        <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button>
        <button class="button-solid" @click="disableoldcount">{{$t('account.confirm')}}</button>
      </div> -->
    </account-dialog-if>
    <!-- 禁用/启用账号结果提示(成功) -->
    <!-- v-if="disableAccountSucVisible" -->
    <account-dialog
      :title="$t('account.accountStatus')"
      :visible.sync="disableAccountSucVisible"
      :class="{
        showDialog: disableAccountSucVisible,
        hideDialog: !disableAccountSucVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <!-- <span class="showresulttext">{{$t('account.modifiedsuccess')}}</span> -->
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button
              class="btn btn-dark"
              @click="disableAccountSucVisible = false"
            >
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 禁用/启用账号结果提示(失败) -->
    <!-- v-if="disableAccountFailVisible" -->
    <account-dialog
      :title="$t('account.accountStatus')"
      :visible.sync="disableAccountFailVisible"
      :class="{
        showDialog: disableAccountFailVisible,
        hideDialog: !disableAccountFailVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button
              class="btn btn-dark"
              @click="disableAccountFailVisible = false"
            >
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </account-dialog>

    <!-- 重置密码 -->
    <!-- v-if="showResetpwdDialog" -->
    <!-- :class="{'showDialog': showResetpwdDialog, 'hideDialog': !showResetpwdDialog}" -->
    <account-dialog-if
      :title="$t('account.resetPwd')"
      :visible.sync="showResetpwdDialog"
      :width="'500px'"
      v-if="showResetpwdDialog"
      noFooter
    >
      <el-form
        slot="content"
        class="chongzhi grid"
        ref="resetform"
        :model="resetform"
        :rules="resetRules"
      >
        <el-form-item :label="$t('account.accountName1')" prop="usr">
          <el-input :value="resetform.usr" auto-complete="off" disabled>
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.newPwd1')" prop="newpwd">
          <el-input
            v-model.trim="resetform.newpwd"
            :placeholder="$t('account.newPwd')"
            type="text"
            class="password"
            clearable
            @clear="pwdcheck"
            @input.native="NewPasswordlevel"
            @keyup.enter.native="$refs.resetconfPwd.focus()"
          >
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div
              :class="passpwdError ? 'pwd_span' : 'sucess'"
              v-show="!strength"
            >
              <span>{{ pwdtip }}</span>
            </div>
            <div class="input_span" v-show="strength">
              <span style="font-size: 12px; font-weight: bold">{{
                $t("signup.qiangdu")
              }}</span>
              <span class="juxing" ref="NewPasswordlevel"></span>
              <span
                style="font-size: 12px; font-weight: bold; margin-left: 5px"
                >{{ count }}</span
              >
            </div>
            <!-- <span>{{usrtip}}</span> -->
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.confirmpassword1')" prop="confPwd">
          <el-input
            v-model.trim="resetform.confPwd"
            :placeholder="$t('account.confirmpassword')"
            type="text"
            class="password"
            clearable
            ref="resetconfPwd"
            @keyup.enter.native="resetpwdold"
          >
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="confpwdError ? 'confpwd_span' : 'sucess'">
              <span>{{ confpwdtip }}</span>
            </div>
          </div>
        </el-form-item>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align: right">
          <button type="button" class="btn btn-dark" @click="resetpwdold">
            {{ $t("account.confirm") }}
          </button>
          <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
        </div>
      </el-form>
      <div slot="footer">
        <!-- <button class="button-solid" @click="resetpwdold">{{$t('account.confirm')}}</button> -->
        <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
      </div>
    </account-dialog-if>
    <!-- 重置密码结果提示(成功) -->
    <!-- v-if="resetPwdSucVisible" -->
    <account-dialog
      :title="$t('account.resetPwd')"
      :visible.sync="resetPwdSucVisible"
      :class="{
        showDialog: resetPwdSucVisible,
        hideDialog: !resetPwdSucVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t("account.resetPwdSuc") }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="resetPwdSucVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 重置密码结果提示(失败) -->
    <!-- v-if="resetPwdFailVisible" -->
    <account-dialog
      :title="$t('account.resetPwd')"
      :visible.sync="resetPwdFailVisible"
      :class="{
        showDialog: resetPwdFailVisible,
        hideDialog: !resetPwdFailVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="resetPwdFailVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </account-dialog>

    <!-- 删除用户 去掉弹框的heard不加title=""和footer noFooter -->
    <!-- v-if="showDeletecountDialog" -->
    <account-dialog
      :title="$t('account.deleteUser')"
      :visible.sync="showDeletecountDialog"
      :width="'450px'"
      :class="{
        showDialog: showDeletecountDialog,
        hideDialog: !showDeletecountDialog,
      }"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width: 100%; text-align: left">{{
            $t("account.confirmDelete")
          }}</span>
        </div>
        <div class="disabledescr">
          <span
            style="
              width: 100%;
              text-align: left;
              margin-top: 28px;
              color: rgba(255, 255, 255, 0.7);
            "
            >{{ $t("account.notRecovered") }}</span
          >
        </div>
        <!-- {{$t('account.confirmDelete')}}</div> -->
        <div class="deletfotter" style="text-align: right; margin-top: 28px">
          <button
            type="button"
            class="btn btn-dark"
            style="margin-right: 10px"
            @click="deleteoldcount"
          >
            {{ $t("account.confirm") }}
          </button>
          <button
            type="button"
            class="btn btn-light"
            @click="showDeletecountDialog = false"
          >
            {{ $t("account.cancel") }}
          </button>
        </div>
      </div>
    </account-dialog>
    <!-- 删除账号结果提示(成功) -->
    <!-- v-if="delAccountSucVisible" -->
    <account-dialog
      :title="$t('account.deleteUser')"
      :visible.sync="delAccountSucVisible"
      :class="{
        showDialog: delAccountSucVisible,
        hideDialog: !delAccountSucVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{
            $t("account.Deletesuccessfully")
          }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="delAccountSucVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 删除账号结果提示(失败) -->
    <!-- v-if="delAccountFailVisible" -->
    <account-dialog
      :title="$t('account.deleteUser')"
      :visible.sync="delAccountFailVisible"
      :class="{
        showDialog: delAccountFailVisible,
        hideDialog: !delAccountFailVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="delAccountFailVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </account-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import accountDialog from "@/components/dialognew";
import accountDialogIf from "@/components/dialognew/flowIndex";
import encryption from "@/assets/js/encryption";
import cookie from "@/assets/js/cookie";
export default {
  components: {
    accountDialog,
    accountDialogIf,
  },
  // props: {
  //   accountInfo: {
  //     type: Object
  //   }
  // },
  data() {
    var validateusr = (rule, value, callback) => {
      var ref = /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/;
      if (!value) {
        callback(new Error(""));
        this.usrtip = this.$t("message.uname_is_required");
        this.isError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.usrtip = this.$t("signup.usrformat");
        this.isError = true;
      } else {
        callback();
      }
    };
    var validatepwd = (rule, value, callback) => {
      var ref = /^[\w]{6,32}$/;
      if (!value) {
        // 原
        // callback(new Error(""));
        // this.pwdtip = this.$t("message.pwd_is_required");
        // this.passpwdError = true;
        // 改
        callback(new Error(this.$t("message.pwd_is_required")));
        this.passpwdError = true;
      } else if (!ref.test(value)) {
        // 原
        // callback(new Error(""));
        // this.pwdtip = this.$t("signup.pwdformat");
        // this.passpwdError = true;
        // 改
        callback(new Error(this.$t("signup.pwdformat")));
        this.passpwdError = true;
      } else {
        callback();
      }
    };
    //新建账号的密码确认
    var validateconfPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdAgain");
        this.confpwdError = true;
      } else if (value !== this.form.pwd) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdNotsame");
        this.confpwdError = true;
      } else {
        this.confpwdtip = "";
        callback();
      }
    };
    //重置密码的密码确认
    var validateconfNewpwd = (rule, value, callback) => {
      if (!value) {
        // 原
        // callback(new Error(""));
        // this.confpwdtip = this.$t("message.pwdAgain");
        // this.confpwdError = true;
        // 改
        callback(new Error(this.$t("message.pwdAgain")));
        this.confpwdError = true;
      } else if (value !== this.resetform.newpwd) {
        // 原
        // callback(new Error(""));
        // this.confpwdtip = this.$t("message.pwdNotsame");
        // this.confpwdError = true;
        // 改
        callback(new Error(this.$t("message.pwdNotsame")));
        this.confpwdError = true;
      } else {
        this.confpwdtip = "";
        callback();
      }
    };
    var validateemail = (rule, value, callback) => {
      var ref = /^(?=\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$).{0,64}$/;
      if (!value) {
        callback(new Error(""));
        this.emailtip = this.$t("message.email_is_required");
        this.emailError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.emailtip = this.$t("message.email_info");
        this.emailError = true;
      } else {
        this.emailtip = "";
        callback();
      }
    };
    var validatephone = (rule, value, callback) => {
      var ref = /^\d{6,32}$/;
      if (!value) {
        callback(new Error(""));
        this.phonetip = this.$t("message.mobile_is_required");
        this.phoneError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.phonetip = this.$t("signup.mobileformat");
        this.phoneError = true;
      } else {
        this.phonetip = " ";
        callback();
      }
    };
    return {
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo: sessionStorage.getItem("disPermissionsLogo")
        ? JSON.parse(sessionStorage.getItem("disPermissionsLogo"))
        : false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")
        ? JSON.parse(sessionStorage.getItem("buttonArr"))
        : [],
      DistRoleList: [], //关联角色
      dataoggerSwithControl: true,
      // 默认头像
      defaultAvatar:
        document.location.protocol +
        "//img.shinemonitor.com/img/2019/12/19/201912191850044046DC0FD27.png",
      // 操作返回提示
      deviceTipMsg: "",
      // 编辑用户信息
      usrDatas: {
        mobile: "",
        qname: "",
        usr: "",
        email: "",
        role: "",
        roleId: "",
      },
      // 编辑用户规则
      editRules: {
        email: [
          // {
          //   required: true,
          //   message: this.$t("message.email_is_required"),
          //   trigger: "blur"
          // },
          {
            pattern:
              /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: this.$t("message.email_info"),
            trigger: "blur",
          },
        ],
        mobile: [
          // {
          //   required: true,
          //   message: this.$t("message.mobile_is_required"),
          //   trigger: "blur"
          // },
          {
            pattern: /^\d{6,32}$/,
            message: this.$t("signup.mobileformat"),
            trigger: "blur",
          },
        ],
      },
      loadingeditcount: false,
      params: "",
      // 重置密码弹窗
      showResetpwdDialog: false,
      // 重置密码成功提示弹窗
      resetPwdSucVisible: false,
      // 重置密码失败提示弹窗
      resetPwdFailVisible: false,
      // 重置密码数据
      resetform: {
        usr: "",
        newpwd: "",
        confPwd: "",
      },
      // 重置密码规则
      resetRules: {
        usr: [
          {
            required: true,
            message: this.$t("message.uname_is_required"),
            trigger: "blur",
          },
        ],
        newpwd: [{ required: true, validator: validatepwd, trigger: "change" }],
        // 确认密码
        confPwd: [
          { required: true, validator: validateconfNewpwd, trigger: "change" },
        ],
      },
      // 重置密码所需字段
      confpwdError: false,
      isError: false,
      emailError: false,
      passpwdError: false,
      phoneError: false,
      Bytes: "",
      count: "",
      Byte: false,
      usrtip: "",
      pwdtip: "",
      emailtip: "",
      phonetip: "",
      confpwdtip: "",
      strength: false,
      // 删除用户弹窗
      showDeletecountDialog: false,
      // 删除账号成功提示弹窗
      delAccountSucVisible: false,
      // 删除账号失败提示弹窗
      delAccountFailVisible: false,
      // 该账户下设备列表
      deviceList: [
        // {
        //   devalias: "cn-名称",
        //   sn: "cn-sn000000001",
        //   status: 1,
        //   devcode: "cn-2304",
        //   pn: "cn-pn111111111",
        //   devaddr: "cn-1",
        //   collalias: "cn-数采器别名",
        //   usr: "cn-所属用户",
        //   devtype: "cn-设备型号",
        // }
      ],
      deviceNum: 0, //设备数量
      loadingDevice: false,
      emptyText: false,
      paginationControl: false,
      // 分页数据
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15,
      },
      searchOptions: {
        // 活跃状态
        activeStatus: {
          true: {
            label: this.$t("statistic.active"),
            class: "active",
          },
          false: {
            label: this.$t("statistic.inactive"),
            class: "inactive",
          },
        },
        // 用户状态
        accountStatus: {
          true: {
            label: this.$t("account.enable"),
            class: "active",
          },
          false: {
            label: this.$t("account.disable"),
            class: "inactivedis",
          },
        },
        // 用户分组
        accountGroup: [],
      },
      // 编辑用户弹窗
      showEditcountDialog: false,
      // 编辑账号成功提示弹窗
      editAccountSucVisible: false,
      // 编辑账号失败提示弹窗
      editAccountFailVisible: false,
      // 禁用启用弹窗
      showdisablecountDialog: false,
      // 禁用账号成功提示弹窗
      disableAccountSucVisible: false,
      // 禁用账号失败提示弹窗
      disableAccountFailVisible: false,
      //用户昵称
      qnameData: {
        qname: "",
      },
      groupListData: [],
      groupListData1: {
        id: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      accountInfo: "getAccountInfo",
      groupIsShow: "getGroupIsShow",
    }),
    // 用户禁启用标题
    disAndEnTitle() {
      let aim = this.params.enable.class;
      let res;
      switch (aim) {
        // 已启用系列
        case "active":
          res = this.$t("account.disable");
          // res = "禁用用户"
          break;
        // 已禁用系列
        case "inactivedis":
          res = this.$t("account.enable");
          // res = "启用用户"
          break;
        // 默认
        default:
          res = "";
          break;
      }
      return res;
    },
  },
  watch: {
    accountInfo: {
      handler() {
        // 该账户下设备列表
        this.getDeviceList();
        if (this.accountInfo.roleNew == this.$t("account.distributor")) {
          this.$set(this.accountInfo, "roleType", 2);
        } else if (this.accountInfo.roleNew == this.$t("account.plantOwner")) {
          this.$set(this.accountInfo, "roleType", 0);
        }
      },
      deep: true,
    },
  },
  created() {
    // 该账户下设备列表
    this.getDeviceList();
    this.getGroupListData();
    // 获取权限角色，厂家创建经销商时
    this.getDistRoleList();
    if (this.accountInfo.roleNew == this.$t("account.distributor")) {
      this.$set(this.accountInfo, "roleType", 2);
    } else if (this.accountInfo.roleNew == this.$t("account.plantOwner")) {
      this.$set(this.accountInfo, "roleType", 0);
    }
  },
  methods: {
    editGroupVisible(visible) {
      if (
        visible &&
        this.disPermissionsLogo &&
        !this.btnList.includes("group")
      ) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
    },
    //修改用户分组
    editGroup() {
      let param = {
        id: this.groupListData1.id,
        uid: this.accountInfo.uidNew,
      };
      this.$request.get("addAccountToGroup", param).then((res) => {
        if (res.err == 0) {
          this.$message.success(this.$t("group.editsuc"));
        }
      });
    },
    //获取分组列表
    getGroupListData() {
      let param = {};
      this.$request.get("queryAccountGroup", param).then((res) => {
        if (res.err == 0) {
          this.groupListData = res.dat.group;
        }
      });
    },
    getDistRoleList() {
      this.$request.get("queryDistRoleList").then((res) => {
        if (res.err == 0) {
          this.DistRoleList = res.dat;
        } else {
          this.DistRoleList = [];
        }
      });
    },
    //编辑用户昵称
    editNickname() {
      let param = {
        qname: this.qnameData.qname,
        // email:this.accountInfo.emailNew,
        // mobile: this.accountInfo.mobileNew,
        uid: this.accountInfo.uidNew,
      };
      this.$request.get("editSubAccount", param).then((res) => {
        if (res.err == 0) {
          this.$store.state.event.updateAccountList = true;
          this.$store.commit("saveAccountInfo", {
            qnameNew: this.qnameData.qname, // 用户昵称
          });
        } else {
          this.qnameData.qname = this.accountInfo.qnameNew;
        }
      });
    },
    // 该账户下设备列表
    getDeviceList(reset) {
      if (!this.accountInfo.qnameNew || this.accountInfo.qnameNew == "--") {
        this.qnameData.qname = this.accountInfo.usrNew;
      } else {
        this.qnameData.qname = this.accountInfo.qnameNew;
      }
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        // ...this.search,
        uid: this.accountInfo.uidNew,
        usr: this.accountInfo.usrNew,
        devtype: 2304,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pagesize,
      };
      this.loadingDevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then((res) => {
        if (res.code === 0) {
          this.deviceNum = res.data.total;
          this.deviceList = this.Fnreturndev(res);
          this.pagination.total = res.data.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true;
          }
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.deviceList = [];
          this.deviceNum = 0;
          this.pagination.total = 0;
        }
        this.loadingDevice = false;
      });
    },
    // 点击返回账户列表总表
    backAccountList() {
      this.$store.commit("saveAccountInfo", {
        qnameNew: (this.qnameData.qname = ""), // 用户昵称
      });
      if (this.groupIsShow.groupIsShow == 1) {
        this.$request.get("queryAccountGroup").then((res) => {
          if (res.err == 0 && res.dat.group.length) {
            this.$store.commit("saveGroupIdClick", {
              groupIdClick: res.dat.group[0].id,
              groupNameClick: res.dat.group[0].name,
            });
          }
        });
      }
      this.$store.state.event.sidebartabUsrGroup = true;
      // 通知显示table(隐藏账号信息页)
      this.$emit("noticeDeviceBox", true);
      // 清空所存store(暂未发现必须)
    },
    // 点击用户名打开该用户窗口
    enterAccount(info) {
      if (
        this.disPermissionsLogo &&
        !this.btnList.includes("sub-account_access")
      ) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      // console.log("=>xinye");
      // console.log("info", info);
      // 非储能用户不能跳转
      if (info.sourceNew != 1) {
        this.$message.error(this.$t("account.cannotRedirect"));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uidNew })
        .then((res) => {
          if (res.err === 0) {
            // console.log("[single-secret]", res.dat.secret);
            let info = {
              secret: res.dat.secret,
              token: res.dat.token,
            };
            if (
              res.dat.role == 2 &&
              this.$store.state.user.riyueyuanPermissionMark
            ) {
              this.$request
                .customGet(info, "queryAccountInfo")
                .then((result) => {
                  if (
                    result.err === 0 &&
                    result.dat.permission &&
                    result.dat.permission.length > 0
                  ) {
                    var moduleArr = [],
                      firstPageArr = [],
                      secPageArr = [],
                      buttonArr = [];
                    result.dat.permission.forEach((item) => {
                      if (item.isCheck) moduleArr.push(item.action);
                      if (item.buttons) {
                        for (
                          var i = 0, length = item.buttons.length;
                          i < length;
                          i++
                        ) {
                          if (item.buttons[i].isCheck) {
                            buttonArr.push(item.buttons[i].action);
                          }
                        }
                      }
                      item.first_menus.forEach((firstItem) => {
                        if (firstItem.isCheck)
                          firstPageArr.push(firstItem.action);
                        if (firstItem.buttons) {
                          for (
                            var i = 0, length = firstItem.buttons.length;
                            i < length;
                            i++
                          ) {
                            if (firstItem.buttons[i].isCheck) {
                              buttonArr.push(firstItem.buttons[i].action);
                            }
                          }
                        }
                        firstItem.second_menus.forEach((secItem) => {
                          if (secItem.isCheck) secPageArr.push(secItem.action);
                          if (secItem.buttons) {
                            for (
                              var i = 0, length = secItem.buttons.length;
                              i < length;
                              i++
                            ) {
                              if (secItem.buttons[i].isCheck) {
                                buttonArr.push(secItem.buttons[i].action);
                              }
                            }
                          }
                        });
                      });
                    });

                    let routeUrl = this.$router.resolve({
                      path: "/home",
                      query: {
                        secret: res.dat.secret,
                        token: res.dat.token,
                        role: res.dat.role,
                        pprAuth: res.dat.pprAuth,
                      },
                    });
                    const newWindow = window.open(routeUrl.href, "_blank");
                    if (newWindow) {
                      newWindow.sessionStorage.setItem(
                        "moduleArr",
                        JSON.stringify(moduleArr)
                      );
                      newWindow.sessionStorage.setItem(
                        "firstPageArr",
                        JSON.stringify(firstPageArr)
                      );
                      newWindow.sessionStorage.setItem(
                        "secPageArr",
                        JSON.stringify(secPageArr)
                      );
                      newWindow.sessionStorage.setItem(
                        "buttonArr",
                        JSON.stringify(buttonArr)
                      );
                      newWindow.sessionStorage.setItem(
                        "disPermissionsLogo",
                        true
                      );
                    }
                  } else if (
                    result.err === 0 &&
                    result.dat.permission &&
                    result.dat.permission.length == 0
                  ) {
                    this.toNoPermission(res);
                  } else {
                    this.$message.error(this.$t(`errCode.${result.err}`));
                  }
                });
            } else {
              this.toNoPermission(res);
            }
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    toNoPermission(res) {
      let routeUrl = this.$router.resolve({
        path: "/home",
        query: {
          secret: res.dat.secret,
          token: res.dat.token,
          role: res.dat.role,
          pprAuth: res.dat.pprAuth,
        },
      });
      const newWindow = window.open(routeUrl.href, "_blank");
      // 在新窗口的上下文中设置sessionStorage参数
      newWindow.sessionStorage.setItem("disPermissionsLogo", false);
      newWindow.sessionStorage.removeItem("moduleArr");
      newWindow.sessionStorage.removeItem("firstPageArr");
      newWindow.sessionStorage.removeItem("secPageArr");
      newWindow.sessionStorage.removeItem("buttonArr");
    },
    // 编辑用户弹窗
    editcount(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("edit_account")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.showEditcountDialog = true;
      this.params = info;
      if (info.roleNew == this.$t("account.distributor")) {
        this.$set(this.params, "roleType", 2);
      } else if (info.roleNew == this.$t("account.plantOwner")) {
        this.$set(this.params, "roleType", 0);
      }
      this.usrDatas.role = info.roleNew;
      this.usrDatas.usr = info.usrNew;
      this.usrDatas.qname = info.qnameNew;
      this.usrDatas.mobile = info.mobileNew == "--" ? "" : info.mobileNew;
      this.usrDatas.email = info.emailNew == "--" ? "" : info.emailNew;
      this.usrDatas.roleId = info.rolePermissionId ? info.rolePermissionId : "";
      this.dataoggerSwithControl = info.addCollectorPermissions;
      // this.loadingeditcount = true;
      // this.$request.get("webQueryUsrEs", { uid: this.params.uidNew }).then(res => {
      //   if (res.err == 0) {
      //     (res.dat.account[0].role =
      //       res.dat.account[0].role == "2"
      //         ? this.$t("account.distributor")
      //         : this.$t("account.plantOwner")),
      //       (this.usrDatas = res.dat.account[0]);
      //       this.dataoggerSwithControl = res.dat.account[0].addCollectorPermissions
      //   } else {
      //     this.$message.error(this.$t(`errCode.${res.err}`));
      //   }
      //   this.loadingeditcount = false;
      // });
      console.log(
        this.accountInfo.roleType,
        this.$store.state.user.riyueyuanPermissionMark,
        this.$store.state.user.riyueyuanUserTypeRid
      );
    },
    // 编辑用户提交
    editoldcount() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return false;
        let addCollectorPermissionsVal;
        if (this.$store.state.user.role == 2 && this.params.roleType == 2) {
          addCollectorPermissionsVal = this.$store.state.user
            .addCollectorPermissions
            ? true
            : false;
        } else {
          addCollectorPermissionsVal =
            this.params.roleType == 2 ? this.dataoggerSwithControl : "";
        }
        this.$request
          .get("editSubAccount", {
            uid: this.params.uidNew,
            qname: this.usrDatas.qname || " ",
            mobile: this.usrDatas.mobile,
            email: this.usrDatas.email,
            roleId:
              this.$store.state.user.role == 1 && this.params.roleType == 2
                ? this.usrDatas.roleId
                : "",
            addCollectorPermissions: addCollectorPermissionsVal,
          })
          .then((res) => {
            if (res.err == 0) {
              // this.$message.success(this.$t("account.modifiedsuccess"));
              this.showEditcountDialog = false;
              this.editAccountSucVisible = true;
              // this.getAccountList();
              // 通知侧栏更新账户列表
              this.$store.state.event.updateAccountList = true;
              // 更新store(因是点击切换不易通知更新故用this.usrDatas赋值)
              this.$store.commit("saveAccountInfo", {
                qnameNew: this.usrDatas.qname, // 用户昵称
                mobileNew: this.usrDatas.mobile, // 电话
                emailNew: this.usrDatas.email, // 邮箱
                rolePermissionId:
                  this.$store.state.user.role == 1 && this.params.roleType == 2
                    ? this.usrDatas.roleId
                    : "", //权限id
              });
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.editAccountFailVisible = true;
            }
          });
      });
    },
    // 校验
    Bytecheck() {
      this.Byte = false;
      this.usrtip = this.$t("message.uname_is_required");
    },
    pwdcheck() {
      this.strength = false;
      this.pwdtip = this.$t("message.pwd_is_required");
    },
    emailcheck() {},
    phonecheck() {},
    UserByte() {
      var usernameRegex = /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/;
      if (usernameRegex.test(this.form.name)) {
        //用户格式正确的情况下
        this.Byte = true;
        this.Bytes = this.form.name.length;
      } else {
        this.Byte = false;
        // this.usrtip = this.$t('signup.usrformat')
      }
    },
    Passwordlevel() {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.form.pwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.form.pwd) &&
          reg2.test(this.form.pwd) &&
          reg3.test(this.form.pwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.form.pwd) && reg2.test(this.form.pwd)) ||
          (reg1.test(this.form.pwd) && reg3.test(this.form.pwd)) ||
          (reg2.test(this.form.pwd) && reg3.test(this.form.pwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.form.pwd) ||
          reg2.test(this.form.pwd) ||
          reg3.test(this.form.pwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    NewPasswordlevel() {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.resetform.newpwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.resetform.newpwd) &&
          reg2.test(this.resetform.newpwd) &&
          reg3.test(this.resetform.newpwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.resetform.newpwd) &&
            reg2.test(this.resetform.newpwd)) ||
          (reg1.test(this.resetform.newpwd) &&
            reg3.test(this.resetform.newpwd)) ||
          (reg2.test(this.resetform.newpwd) && reg3.test(this.resetform.newpwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.resetform.newpwd) ||
          reg2.test(this.resetform.newpwd) ||
          reg3.test(this.resetform.newpwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    // 重置密码弹窗
    resetpwd(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("reset_password")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      // console.log("reset-info", info);
      // console.log("reset-info.usrNew", info.usrNew);
      this.showResetpwdDialog = true;
      this.params = info;
      // this.resetform.usr = info.usrNew;
      this.$set(this.resetform, "usr", info.usrNew);
      this.resetform.newpwd = null;
      this.resetform.confPwd = null;

      this.confpwdError = false;
      this.isError = false;
      this.emailError = false;
      this.passpwdError = false;
      this.phoneError = false;
      this.Byte = false;
      this.strength = false;
      this.usrtip = null;
      this.pwdtip = null;
      this.emailtip = null;
      this.phonetip = null;
      this.confpwdtip = null;

      // this.$nextTick(()=> {
      //   this.$refs.resetform.resetFields();
      // });
    },
    // 重置密码提交
    resetpwdold() {
      // console.log("chongzhiMimaSingle");
      // console.log("this.params.uidNew", this.params.uidNew);
      this.$refs.resetform.validate((valid) => {
        if (!valid) return false;
        this.$request
          .get("resetSubUsrPassword", {
            uid: this.params.uidNew,
            newpwd: encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.resetform.newpwd),
                this.$store.state.user.secret
                // cookie.getCookie("secret"),
              )
            ),
          })
          .then((res) => {
            if (res.err == 0) {
              // this.$message.success(this.$t("account.pwdresetsuccess"));
              this.resetPwdSucVisible = true;
              this.showResetpwdDialog = false;
              // this.getAccountList();
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.resetPwdFailVisible = true;
            }
          });
      });
    },
    // 删除用户弹窗
    detelecount(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("delete_account")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      // console.log("del-alert-info", info);
      this.showDeletecountDialog = true;
      this.params = info;
    },
    // 删除用户提交
    deleteoldcount() {
      // console.log("del-submit-this.params", this.params);
      // console.log("[roleNew]", this.params.roleNew);
      // console.log("[distributor]", this.$t("account.distributor"));
      // console.log("[plantOwner]", this.$t("account.plantOwner"));
      // console.log("[filter]", this.$filter.role(this.params.roleNew).name);
      // return;

      //删除经销商账号(this.params.roleNew )
      if (this.params.roleNew == this.$t("account.distributor")) {
        this.$request
          .get("delDist", {
            uid: this.params.uidNew,
          })
          .then((res) => {
            if (res.err == 0) {
              this.$message.success(this.$t("account.Deletesuccessfully"));
              this.delAccountSucVisible = true;
              // this.showDeletecountDialog = false;
              // this.getAccountList();
              // 通知侧栏更新树形控件
              this.$store.state.event.sidebarmodeTree = true;
              // 删除成功后应跳转账户列表页
              this.showDeletecountDialog = false;
              // 删除成功后通知侧栏账户列表更新
              this.$store.state.event.updateAccountList = true;
              // 通知显示账号信息页(显示table)
              this.$emit("noticeDeviceBox", true);
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.delAccountFailVisible = true;
            }
          });
      } //删除电站业主账号(this.params.roleNew )
      else if (this.params.roleNew == this.$t("account.plantOwner")) {
        this.$request
          .get("delPlantOwner", {
            uid: this.params.uidNew,
          })
          .then((res) => {
            if (res.err == 0) {
              this.$message.success(this.$t("account.Deletesuccessfully"));
              this.delAccountSucVisible = true;
              // this.showDeletecountDialog = false;
              // this.getAccountList();
              // 通知侧栏更新树形控件
              this.$store.state.event.sidebarmodeTree = true;
              // 删除成功后应跳转账户列表页
              this.showDeletecountDialog = false;
              // 删除成功后通知侧栏账户列表更新
              this.$store.state.event.updateAccountList = true;
              // 通知显示账号信息页(显示table)
              this.$emit("noticeDeviceBox", true);
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.delAccountFailVisible = true;
            }
          });
      }
    },
    // 点击进入设备
    enterDevice(info) {
      if (!info.uid) {
        this.$message.error(this.$t(`device.noAuth`));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then((res) => {
          if (res.err === 0) {
            // console.log('管理员进入设备', res.dat)
            let routeUrl = this.$router.resolve({
              // path: "/general/home",
              path: "/generalNew/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
                devcode: info.devcode,
                pn: info.pn,
                devaddr: info.devaddr,
                sn: info.sn,
              },
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 禁用账号弹窗
    disablecount(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("disable")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      // console.log("禁用/启用=>info", info);
      this.showdisablecountDialog = true;
      // this.params = {...info};
      this.params = {
        avatar: info.avatarNew,
        qname: info.qnameNew,
        usr: info.usrNew,
        enable: info.enableNew,
        active: info.activeNew,
        role: info.roleNew,
        mobile: info.mobileNew,
        email: info.emailNew,
        group: info.groupNew,
        createTime: info.createTimeNew,
        lastLoginTs: info.lastLoginTsNew,
        source: info.sourceNew,
        uid: info.uidNew,
      };
      // console.log("this.params", this.params);
      // this.params.enable = this.searchOptions.accountStatus[info.enableNew];
    },
    // 禁用账号提交
    disableoldcount() {
      let paramTo = {
        enable: this.params.enable.class == "inactivedis" ? "true" : "false",
        // uid: this.params.uidNew
        uid: this.params.uid,
      };
      this.$request.get("disableOrEnableAccount", paramTo).then((res) => {
        if (res.err == 0) {
          if (this.params.enable.class == "inactivedis") {
            // this.$message.success(this.$t("account.enablesuccess"));
            this.deviceTipMsg = this.$t("account.enablesuccess");
          } else {
            // this.$message.success(this.$t("account.disablesuccess"));
            this.deviceTipMsg = this.$t("account.disablesuccess");
          }
          this.disableAccountSucVisible = true;
          this.showdisablecountDialog = false;
          // this.getAccountList();
          // 通知侧栏更新账户列表
          this.$store.state.event.updateAccountList = true;
          // 更新store(因是点击切换不易通知更新故用this.usrDatas赋值)
          // this.$store.commit("saveAccountInfo", {
          //   enableNew: !this.params.enableNew, // 禁用启用(取反)
          // });
          if (paramTo.enable == "true") {
            this.$store.commit("saveAccountInfo", {
              enableNew: this.searchOptions.accountStatus[true], // (取反)
            });
          } else {
            this.$store.commit("saveAccountInfo", {
              enableNew: this.searchOptions.accountStatus[false], // (取反)
            });
          }
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.deviceTipMsg = this.$t(`errCode.${res.err}`);
          this.disableAccountFailVisible = true;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.single-box {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  // align-items: center;
  background: rgba(45, 63, 75, 1);
  padding: 20px;

  .help-label {
    font-size: 12px;
    color: rgba(235, 235, 235, 0.8);
    margin-left: 20px;
    display: inline-block;
  }

  //开关按钮
  .eb-switch {
    &.el-switch {
      // 轨道
      /deep/.el-switch__core {
        position: relative;
        vertical-align: middle;
        margin: 0;
        display: inline-block;
        width: 40px;
        height: 20px;
        outline: 0;
        border-radius: 10px;
        box-sizing: border-box;
        background-color: #222d35;
        border: 1px solid #707973;
        cursor: pointer;
        transition: border-color 0.3s, background-color 0.3s;

        // transition: unset;
        // 开关把手
        &:after {
          content: "";
          width: 12px;
          height: 12px;
          top: 3px;
          left: 3px;
          box-sizing: border-box;
          background-color: #222d35;
          border: 1px solid #adb9c0;
          border-radius: 100%;
        }
      }
    }

    // 激活(true)
    &.el-switch.is-checked {
      // 轨道
      /deep/.el-switch__core {
        background-color: @primaryTextColor;
        border: 1px solid @primaryTextColor;

        // 开关把手
        &:after {
          content: "";
          left: 100%;
          margin-left: -16px;
          background-color: rgba(255, 255, 255, 1);
          border: 1px solid rgba(255, 255, 255, 1);
        }
      }
    }
  }

  // 弹窗输入框间距
  .grid {
    grid-row-gap: 20px;
  }

  // Loading
  /deep/.el-loading-spinner i {
    color: @primaryTextColor;
  }

  // 表格标题
  /deep/.el-form-item__label {
    color: #ffffff;
  }

  // 加载动画
  .tableloding {
    // 遮罩
    /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, 0.5);
    }

    // 花形
    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }

    // 环形
    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor;
    }
  }

  // 可点击跳转的标题
  .redirect {
    color: @primaryTextColor;
  }

  // 统一按钮
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .single-info {
    border-bottom: 3px solid rgba(45, 63, 75);
    width: 100%;
    background: rgba(34, 45, 53, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 24px 13px 20px;

    .info-status {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      color: #b7b7b7;

      /deep/.el-input__inner {
        background-color: #202d35;
        border: none;
        border-radius: 0;
        color: #fff;
        padding: 0;
        width: 100px;
        height: 26px;
      }

      .info-title {
        // height: 24px;
        font-weight: bold;
        font-size: 20px;
        color: #ffffff;
        background-color: #202d35;

        // background-color:red;
        /deep/.el-inpit {
          padding: 0;
          margin: 0;
          width: 100px;
        }
      }

      i {
        font-size: 20px;
      }

      .info-enable {
        margin-left: 16px;
        color: #b7b7b7;
      }

      .info-enable-yes {
        color: #16d09a;
      }

      .info-active {
        width: 100%;
        margin-left: 16px;
        color: #b7b7b7;
        border: 1px solid #b7b7b7;
        border-radius: 5px;
        padding: 2px 6px;
        font-size: 12px;
      }

      .info-active-yes {
        color: #16d09a;
        border: 1px solid #16d09a;
      }
    }

    .info-tool {
      display: flex;
      align-items: flex-end;
      height: 100%;

      .operation {
        // width: 86px;
        // height: 32px;
        padding: 4px 10px;
        border-radius: 6px;
        border: 1px solid rgba(85, 180, 145, 1);
        box-sizing: border-box;
        background-color: @primaryButtonColor;
        color: #ffffff;
        // display: flex;
        // align-items: center;
        display: inline-block;

        // margin-bottom: 20px;
        i {
          font-size: 18px;
          // vertical-align: middle;
        }

        .icon-text1 {
          display: inline-block;
          line-height: 18px;
          margin-left: 6px;
        }

        // 是否关注
        .followno {
          background-image: url(../../../assets/img/general/Icon_Operate_Follow_Light.png);
          background-size: contain;
        }

        .followyes {
          background-image: url(../../../assets/img/general/Icon_Operate_Follow_Dark.png);
          background-size: 22px 22px;
        }

        .ico-export {
          background-image: url(../../../assets/img/general/Icon_Operate_Export.png);
        }

        .ico-debug {
          background-image: url(../../../assets/img/general/Icon_Operate_Debug.png);
        }

        .ico-control {
          background-image: url(../../../assets/img/general/Icon_Operate_Control.png);
        }

        .ico-upgrade {
          background-image: url(../../../assets/img/general/Icon_Operate_Upgrade.png);
        }

        .ico-delete {
          background-image: url(../../../assets/img/general/Icon_Operate_Delete.png);
        }

        .icobase {
          width: 18px;
          height: 18px;
          display: inline-block;
          background-position: center;
          background-repeat: no-repeat;
          // background-size: contain;
          vertical-align: middle;
        }
      }
    }
  }

  .info-base {
    display: flex;
    background-color: #202d35;
    height: 100%;

    .info-leftbox {
      border-right: 3px solid rgba(45, 63, 75);

      .info-avatar {
        margin: 48px 71px;
        width: 128px;
        height: 128px;
      }

      .info-databox {
        padding: 0 8px;
        color: #ecf3f8;

        .groupBox {
          .groupName2 {
            color: @primaryTextColor;

            /deep/.el-input__inner::placeholder {
              color: @primaryTextColor;
            }

            /deep/.el-input--suffix {
              display: flex;
              justify-content: center;
            }
          }

          // position: relative;
          /deep/.el-select {
            padding: 0;
          }

          /deep/.el-select-dropdown {
            background-color: #222d35;
            border: none;
          }

          /deep/ .el-select-dropdown__item {
            background-color: #222d35;
            color: #fff;
          }

          /deep/.el-input__inner {
            color: @primaryTextColor;
            text-align: right;
            height: 100%;
            background: #202d35;
            border: 0;
            padding: 0;
          }

          /deep/.el-input__suffix {
            display: none;
          }
        }

        .groupName {
          position: relative;
          display: block;
          color: @primaryTextColor;
          cursor: pointer;
          padding: 0;

          // .groupName2 {}

          .groupName1 {
            position: absolute;
            padding: 0;
            right: 0;
          }
        }

        div {
          padding: 12px 10px;
          display: flex;
          justify-content: space-between;
        }

        hr {
          height: 1px;
          background-color: #556570;
          border: none;
          margin: 0;
        }
      }
    }

    .single-deviceList {
      height: 100%;
      flex: 1;
      width: 100%;
      background: rgba(34, 45, 53, 1);
      // margin-top: 20px;
      display: flex;
      flex-direction: column;
      overflow: auto;

      // 滚动条
      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: transparent;
      }

      .total-top {
        color: #ffffff;
        font-size: 16px;
        padding: 10px 15px;
        font-weight: bold;
      }

      .tablemain {
        flex: 1;
        border: none;
        background-color: rgb(34, 45, 53);

        .label {
          .status-icon-shadow {
            width: 14px;
            height: 14px;
            border-radius: 7px;
            margin: 0 14px 0 18px;
          }
        }

        .operation i {
          color: @primaryTextColor;
        }

        /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
          width: 16px;
          height: 16px;
          background: transparent;
          border: 1px solid rgb(180, 184, 193);
          border-radius: 0px;
        }

        /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
          top: 2px;
          left: 5px;
        }

        /deep/.el-table__header th {
          height: 48px;
        }

        /deep/.el-table__header th.is-leaf {
          border-color: rgba(198, 209, 221, 0.5);
          // border-bottom: none;
        }

        /deep/.el-table__header th > .cell {
          font-weight: normal;
          font-size: 12px;
        }

        /deep/.el-table__body tr,
        /deep/.el-table__body td {
          background-color: rgb(34, 45, 53);
          color: #ffffff;
          border-color: rgba(198, 209, 221, 0.5);
        }

        /deep/.el-table__body td.el-table-column--selection {
          background-color: rgb(65, 80, 90);
          color: #ffffff;
        }

        /deep/.el-table__body .cell.el-tooltip {
          font-size: 14px;
        }

        /deep/.el-table__fixed-right::before,
        /deep/.el-table__fixed::before {
          display: none;
        }

        /deep/.el-table--border::after,
        /deep/.el-table--group::after {
          width: 0px;
        }

        ::-webkit-scrollbar {
          width: 6px;
          height: 6px;
          background-color: #222d35;
          z-index: 9999;
        }

        // 关于复选框
        /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
          background: @primaryTextColor;
          border: 1px solid @primaryTextColor;
        }

        /deep/.el-checkbox
          .el-checkbox__input.is-indeterminate
          .el-checkbox__inner {
          background: @primaryTextColor;
          border: 1px solid @primaryTextColor;
        }

        // 关于头部右侧空白
        /deep/.el-table__fixed-right-patch {
          background-color: rgb(65, 80, 90);
          border-bottom: none;
        }

        /deep/th.gutter {
          background-color: rgb(65, 80, 90);
        }

        // 关于表格右侧边线(无效)
        // /deep/&.el-table--border::after{
        //   display: none;
        // }
        // /deep/&.el-table--group::after {
        //   display: none;
        // }
      }

      // 关于表格右侧边线
      /deep/.el-table--border::after {
        display: none;
      }

      /deep/.el-table--group::after {
        display: none;
      }

      .tablebottom {
        // position: relative;
        // bottom: -12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid rgba(198, 209, 221, 0.5);

        // 分页
        .pagination {
          line-height: 48px;
          height: 48px;
          padding: 0;
          margin: 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          /deep/.el-pager li {
            vertical-align: middle;
          }

          /deep/.el-select .el-input {
            width: 90px;
            margin: 0px;
          }

          /deep/.el-input .el-input__inner {
            background-color: #202d35;
            color: #ffffff;
          }

          /deep/.el-input__suffix {
            right: 10px;
          }

          /deep/.el-pagination__sizes {
            margin: 0px;
            height: 48px;
            line-height: 48px;
          }

          /deep/.el-pagination__total {
            color: #fff;
            padding-left: 15px;
            border-left: 1px solid #7b8395;
            height: 48px;
            line-height: 48px;
          }

          /deep/.el-pager li:not(.disabled).active {
            // background: #15C491;
            // color: #ffffff;
            background-color: #2b3842;
            color: #15c491;
          }

          // li:not(.disabled):not(.active):hover
          /deep/.el-pager li:not(.disabled):hover {
            background-color: @primaryColorTransparency30;
            color: rgba(255, 255, 255, 1);
          }

          /deep/.el-pager li {
            background-color: #2b3842;
            color: #7b8395;
          }

          // 页条数下拉
          /deep/.el-select .el-input .el-input__inner {
            border: none;
            height: 48px;
            line-height: 48px;
            border-radius: 0px;
          }

          /deep/.el-select .el-input .el-input__inner:hover {
            background: @primaryColorTransparency30;
          }

          // 跳页
          /deep/.el-pagination__jump {
            color: #ffffff;
          }

          /deep/.el-pagination__editor {
            padding: 0px 6px;
          }

          /deep/.el-pagination__editor.el-input .el-input__inner {
            border: 1px solid #7b8395;
          }
        }

        // 分页前后按钮
        /deep/.el-pagination.is-background .btn-next,
        /deep/.el-pagination.is-background .btn-prev {
          background-color: #2b3842;
          color: #7b8395;
        }

        /deep/.el-pagination.is-background .btn-next:hover,
        /deep/.el-pagination.is-background .btn-prev:hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pagination.is-background button[disabled],
        /deep/.el-pagination.is-background button[disabled]:hover {
          background-color: #2b3842;
          color: #7b8395;
        }
      }
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>